import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Field } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'

import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { MOBILE_COUNTRY_CODES, POPULAR_MOBILE_COUNTRY } from 'constants/mobileCountryCodes'
import Dropdown from 'components/Dropdown'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { ReactComponent as Success } from 'assets/icons/successSmall.svg'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'

import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import { getUserByMobile, saveNudge, sendOtpForSignIn } from 'api/flights/results'
import { errorConfig } from './errorConfig'
import OtpBox from './otpBox'
import { Icon } from '@cleartrip/bento/components/Icon'
import Clevertap from 'analytics'

const VerifyMobileInputField = ({
    toggle,
    mobileAndCountryCodeItem,
    setPageName,
    validateMobileHandler,
    isMobileValid,
    handleLinkClick,
    email,
    mobile,
    countryCode,
    showCloseButton,
    superCoinAddNumber
}) => {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }

    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const [countDown, setCountDown] = useState(0)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const [apiError, setApiError] = useState('')
    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })
    let errorInfo = 'fs-inherit c-inherit pl-2'
    useEffect(() => {
        refs[0]?.current?.focus()
    }, [])

    const getOtp = async () => {
        setApiError('')
        let mobileValid = validateMobileHandler()
        if (mobileValid) {
            const payload = {
                type: 'MOBILE',
                value: mobile,
                countryCode: countryCode,
                action: 'UPDATE_MOBILE'
            }
            const response = await sendOtpForSignIn(payload)
            const { status, data, error } = response || {}
            if (status === 202) {
                if (superCoinAddNumber) {
                    Clevertap.event('Air_UI_Action', {
                        action_name: 'Adding mobile using supercoins toggle',
                        action_value: 'Entered phone number'
                    })
                }
                const { action } = data || {}
                setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER)
            } else {
                const { response = { data: {} } } = error || {}
                const { data = {} } = response
                const { message } = data
                const err = errorConfig[message] || errorConfig.default
                setApiError(err)
            }
        } else {
            ClevertapEvent({
                actionName: 'Invalid_value_entered',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath)
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath,
                field_name: 'mobile',
                form_name: 'VerifyMobile'
            })
        }
    }
    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column mt-150"
            style={{
                width: '410px',
                height: '437px'
            }}
        >
            <div className={`${animatedClass} d-flex flex-1 flex-column`}>
                <ModalHeader
                    title={superCoinAddNumber ? 'Add mobile number' : 'Verify mobile number'}
                    toggle={toggle}
                    showCloseButton={showCloseButton}
                />

                <div className="d-flex flex-column flex-between flex-1">
                    <div>
                        <OfflineToast page="verify mobile number" />
                        {apiError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {apiError}
                                    </span>
                                </div>
                                <Spacer className="pt-4" />
                            </>
                        )}
                        <span className="fs-3 c-neutral-700">{'For account '} </span>{' '}
                        <span className="fs-3 c-neutral-700 fw-600">{email}</span>
                        <Spacer className="mt-3" />
                        {mobileAndCountryCodeItem}
                        <div className="br-4 bg-neutral-0 p-4 mt-5">
                            <div className="fs-3 c-neutral-900 fw-600 pb-3">
                                {'Benefits of verifying mobile number'}
                            </div>
                            <div className="flex flex-middle mb-2">
                                <Icon icon="tick" height={14} width={14} className="c-success-500" />
                                <Spacer className="mr-2" />
                                <span className="fs-2 fw-500 c-neutral-900">{'Faster checkout using saved cards'}</span>
                            </div>
                            <div className="flex flex-middle mb-2">
                                <Icon icon="tick" height={14} width={14} className="c-success-500" />
                                <Spacer className="mr-2" />
                                <span className="fs-2 fw-500 c-neutral-900">{'Use saved traveller details'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-8">
                        <div className="mb-4">
                            <Button
                                size="md"
                                type="secondary"
                                full
                                className="h-10 bg-black-500 hover:bg-black-500 "
                                // onClick={() => goBackAnimation(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)}
                                onClick={async () => {
                                    let mobileValid = validateMobileHandler()

                                    if (mobileValid) {
                                        const response = await getUserByMobile(mobile, countryCode)
                                        const { status } = response
                                        if (status === 200) {
                                            setApiError('Phone number already associated with another account.')
                                        } else {
                                            getOtp()
                                        }
                                    }
                                }}
                            >
                                <span className="fs-3 fw-550">{'Get OTP'}</span>
                            </Button>
                        </div>
                        <div
                            className="ta-center fs-3 fw-600 c-blue c-pointer"
                            onClick={() => {
                                saveNudge('UPDATE_MOBILE')
                                toggle()
                            }}
                        >
                            Not Now
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VerifyMobileInputField
